function pickRuleFactory(mod) {
  if (typeof mod === "function") return mod;

  if (mod && typeof mod.default === "function") return mod.default;

  if (mod && typeof mod.check === "function") return () => mod;

  if (mod && mod.default && typeof mod.default.check === "function") return () => mod.default;

  throw new Error("[bpmnlint-plugin-kuika] Rule export must be a function or an object with `check`.");
}

module.exports = {
  rules: {
    "screen-assigned": pickRuleFactory(require("./rules/screen-assigned")),
    "gateway-conditions": pickRuleFactory(require("./rules/gateway-conditions")),
    "gateway-join": pickRuleFactory(require("./rules/gateway-join")),
    "gateway-min-outgoing": pickRuleFactory(require("./rules/gateway-min-outgoing")),
    "no-isolated-flow-nodes": pickRuleFactory(require("./rules/no-isolated-flow-nodes")),
    "label-required": pickRuleFactory(require("./rules/label-required")),
    "start-end-required": pickRuleFactory(require("./rules/start-end-required")),
    "steps-required": pickRuleFactory(require("./rules/steps-required")),
    "mi-instance-config": pickRuleFactory(require("./rules/mi-instance-config")),
    "loop-config": pickRuleFactory(require("./rules/loop-config")),
    "boundary-event-has-outgoing": pickRuleFactory(require("./rules/boundary-event-has-outgoing")),
    "missing-incoming-or-outgoing": pickRuleFactory(require("./rules/missing-incoming-or-outgoing")),
    "single-outgoing-non-gateway": pickRuleFactory(require("./rules/single-outgoing-non-gateway")),
    "gateway-duplicate-condition": pickRuleFactory(require("./rules/gateway-duplicate-condition")),
    "system-step-has-action": pickRuleFactory(require("./rules/system-step-has-action")),
    "step-output-unbound": pickRuleFactory(require("./rules/step-output-unbound")),
    "step-action-input-unbound": pickRuleFactory(require("./rules/step-action-input-unbound"))
  }
};
